export const state = {
  activeNav: {},
  activeNavIndex: 0,
  drawerClosed: false,
  drawerTransitioning: false,
  isOpen: false,
  navContent: [
    {
      title: null,
      component: null,
    },
  ],
  drawerTransitionOrigin: 'top left',
  didOpenNavigateDeeper: false,
};

export const getters = {};

export const mutations = {
  pushNavContent(state, newNav) {
    state.navContent.push(newNav);
  },
  popNavContent(state) {
    state.navContent.pop();
  },
  shiftNavContent(state) {
    state.navContent.shift();
  },
  setActiveNav(state, activeNav) {
    state.navContent = [];
    state.navContent.push(activeNav);
    state.activeNavIndex = 0;
    state.isOpen = activeNav.isDrawerOpen !== undefined ? activeNav.isDrawerOpen : true;
  },
  setActiveNavIndex(state, newValue) {
    state.activeNavIndex = newValue;
  },
  keepNavStateButToggleDrawer(state) {
    state.isOpen = !state.isOpen;
  },
  setDrawerState(state) {
    state.isOpen = !state.isOpen;
  },
  setDrawerTransitionOrigin(state, newValue) {
    state.drawerTransitionOrigin = newValue;
  },
  setDrawerTransitioning(state, newValue) {
    state.drawerTransitioning = newValue;
  },
  resetDrawer(state) {
    state.navContent = [];
    state.navContent.push({
      title: 'Kitchen Drawer',
      component: 'KitchenDrawerNav',
    });
    state.activeNavIndex = 0;
  },
  setDidOpenNavigateDeeper(state, value) {
    state.didOpenNavigateDeeper = value;
  },
};

export const actions = {
  toggleDrawer(ctx, { desiredState } = { desiredState: null }) {
    if (ctx.state.isOpen && desiredState !== 'open') {
      ctx.commit('setDrawerState', ctx.state);

      setTimeout(() => {
        ctx.commit('resetDrawer', ctx.state);
      }, 500);
    } else if (desiredState === null || desiredState === 'closed') {
      ctx.commit('setDrawerState', ctx.state);
    }
  },
  navigateDeeper(ctx, newNav) {
    ctx.commit('setDidOpenNavigateDeeper', true);
    //this method is to prevent multiple views of a single component
    //from opening in the NavigateDeeper method
    setTimeout(() => {
      ctx.commit('setDidOpenNavigateDeeper', false);
    }, 700);
    if (newNav.component === 'RecipeDetail') {
      window.clevertap.event.push('Destination', {
        View: 'Recipe Detail',
        'Recipe Title': newNav.title,
        'Recipe ID': newNav.dishId,
      });
    } else {
      window.clevertap.event.push('Destination', { View: newNav.title });
    }
    ctx.commit('setDrawerTransitioning', true);
    // pushNavContent and setActiveNavIndex actions are conflicting during deepLinking
    // so we dynamically set timeouts so the Recipe Detail views render.
    const isDeepLink = (newNav && newNav.deepLink) || (newNav && newNav.component == 'RecipeDetailPublic') || (newNav && newNav.component == 'RecipeDetail');
    const pushNavConentDelay = isDeepLink ? 500 : 0;
    const setActiveNavIndexDelay = isDeepLink ? 1500 : 100;
    setTimeout(() => {
      ctx.commit('pushNavContent', newNav);
    }, pushNavConentDelay);

    setTimeout(() => {
      ctx.commit('setActiveNavIndex', ctx.state.navContent.length - 1);
    }, setActiveNavIndexDelay);

    setTimeout(() => {
      ctx.commit('setDrawerTransitioning', false);
    }, 500);
  },
  navigateHigher(ctx) {
    if (ctx.state.navContent.length > 1) {
      ctx.commit('setDrawerTransitioning', true);
      ctx.commit('setActiveNavIndex', ctx.state.navContent.length - 2);
      handleUpdateUrl(ctx.state.navContent[ctx.state.navContent.length - 2].component);

      setTimeout(() => {
        ctx.commit('setDrawerTransitioning', false);
        ctx.commit('popNavContent');
      }, 500);
    }
  },
};

function handleUpdateUrl(component = null, data = null) {
  if (!component) {
    window.history.replaceState(null, '', window.location.pathname);
  } else {
    switch (component) {
      case 'Recipes':
        window.history.replaceState(null, '', `?deepLink=all-recipes`);
        break;
      case 'Plans':
        window.history.replaceState(null, '', `?deepLink=plans`);
        break;
    }
  }
}
